import React from 'react'
import { useTranslation } from 'react-i18next'

const Privacy: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-text mb-6">{t('footer.privacy')}</h1>

        <div className="bg-white rounded-2xl shadow-sm border border-border p-6 space-y-4 text-sm text-text-secondary">
          <p>{t('privacy.intro')}</p>

          <h2 className="text-lg font-semibold text-text mt-4">{t('privacy.collection.title')}</h2>
          <p>{t('privacy.collection.content')}</p>

          <h2 className="text-lg font-semibold text-text mt-4">{t('privacy.analytics.title')}</h2>
          <p>{t('privacy.analytics.content')}</p>

          <h2 className="text-lg font-semibold text-text mt-4">{t('privacy.thirdParty.title')}</h2>
          <p>{t('privacy.thirdParty.content')}</p>

          <h2 className="text-lg font-semibold text-text mt-4">{t('privacy.retention.title')}</h2>
          <p>{t('privacy.retention.content')}</p>

          <p className="text-text-light mt-6">{t('privacy.lastUpdated')}</p>
        </div>
      </div>
    </div>
  )
}

export default Privacy
